import { recordError } from './Errors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ActionSideEffect<Args extends any[] = any[]> = (
  ...args: Args
) => unknown | Promise<unknown>;

/**
 * Run an asynchronous function within a redux reducer as a side effect of an action.
 *
 * The effect function will run **after** the current action has completed it's state update. This means you can safely
 * use `store.getState()` within the effect function to access the latest store state.
 *
 * It's possible to dispatch multiple actions throughout the effect function such as loading, success, and failure
 * actions.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function runActionSideEffect<Args extends any[]>(
  effect: ActionSideEffect<Args>,
  ...args: Args
): void {
  // Using `promise.resolve()` ensures the current synchronous block of code has completed before running the effect.
  Promise.resolve()
    .then(() => effect(...args))
    .catch(recordError);
}
